<script setup lang="ts">
const { t } = useI18n();
const route = useRoute();

const dashboardSelected = computed(() => {
  return route.name === 'panel-dashboard';
});
</script>

<template>
  <div class=" flex gap-9">
    <ButtonLevel
      class="w-full justify-between"
      :class="{
        '!font-normal !text-gray-800': !dashboardSelected,
      }"
      type="4"
      :title="t('Dashboard').toUpperCase()"
      @click="navigateTo('/panel/dashboard')"
    />

    <ButtonLevel
      class="w-full justify-between"
      :class="{
        '!font-normal !text-gray-800': dashboardSelected,
      }"
      type="4"
      :title="t('Orders_list').toUpperCase()"
      @click="navigateTo('/panel/order-list')"
    />
  </div>
</template>

<style scoped>

</style>
